<template>
  <div>
    <div
      class="titre"
      v-html="$root.copy_content.title + $root.copy_content.subtitle"
    />

    <button type="button" class="button-blue" @click="$emit('close')">
      ← Retour aux fiches
    </button>

    <aside class="_summary">
      <b>Sommaire</b>
      <a
        :href="'#ancre-' + index"
        v-for="(section, index) in infos_formatted.summary"
        v-html="index + 1 + ' → ' + section"
        :key="index"
      />
    </aside>

    <main class="mainText">
      <div
        v-for="(section, index) in infos_formatted.content"
        v-html="section"
        :id="'ancre-' + index"
        :key="index"
      />
    </main>
  </div>
</template>
<script>
import $ from "jquery";

export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  watch: {},
  computed: {
    infos_formatted() {
      const $nodes = $.parseHTML(this.$root.copy_content.infos);
      const $html = $("<div></div>").append($nodes);

      let content = [];
      let summary = [];

      $html.find("h1").each(function() {
        const items = $(this)
          .nextUntil("h1")
          .add(this);

        const html = $("<div></div>")
          .append(items.clone())
          .html();

        content.push(html);
        summary.push($(this).text());
      });

      return {
        content,
        summary,
      };

      // var div = document.createElement("div");
      //       div.innerHTML = this.$root.copy_content.infos.trim();

      // return div.outerHTML;
      // return this.$root.copy_content.infos;
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
._summary {
  max-width: 56vh;
  margin: 0 auto;
  font-size: 80%;
  margin-bottom: calc(var(--spacing) * 2);

  a {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

button {
  display: block;
  margin: calc(var(--spacing) * 2) auto;
}

main {
  max-width: 76vh;
  margin: 0 auto;

  ::v-deep img {
    max-width: 100%;
    height: auto;
  }

  ::v-deep h1 {
    background: white;
  }
}
</style>
